import React, {useLayoutEffect} from 'react';

type VideoProps = {
    src: MediaStream;
    className?: string;
    /** Preview tiles are muted by default. */
    muted?: boolean;
    /** Optional hook for annotation overlay (ReceiverAnnotationOverlay). */
    onVideoRef?: (el: HTMLVideoElement | null) => void;
};

export const Video = ({src, className, muted = true, onVideoRef}: VideoProps) => {
    const [element, setElement] = React.useState<HTMLVideoElement | null>(null);
    const onVideoRefLatest = React.useRef(onVideoRef);
    onVideoRefLatest.current = onVideoRef;

    useLayoutEffect(() => {
        onVideoRefLatest.current?.(element);
        return () => {
            onVideoRefLatest.current?.(null);
        };
    }, [element]);

    React.useEffect(() => {
        if (element) {
            element.srcObject = src;
            element.play().catch((e) => console.log('Could not play preview video', e));
        }
    }, [element, src]);

    return <video muted={muted} ref={setElement} className={className} />;
};
